<div class="topMenu">
    <div class="container golf-wrap">
        @if (isBrowser()){
            @if(!showMenu()){
                @if(backBtn().show){
                    <button class="menu-back-btn" aria-label="Go back" (click)="onBackClick()">
                        <img ngSrc="assets/images/back.svg" alt="" width="9" height="16">
                        @if (backBtn().text){
                            <span>{{backBtn().text}}</span>
                        }
                    </button>
                } @else {
                    <button class="menu-btn" aria-label="Open menu" (click)="showMenu.set(true)">
                        <img ngSrc="assets/images/menu-btn.svg" alt="" width="26" height="12">
                    </button>
                }
            } @else {
                <div class="menu-close" aria-label="Close menu" role="button" tabindex="0" (click)="showMenu.set(false)" (keydown.enter)="showMenu.set(false)"></div>
            }
        }

        
        <div class="menu-wrap" role="navigation" aria-label="Main menu" [class.active]="showMenu()">
            <div class="menu-head">
                <a (click)="showMenu.set(false)" routerLink="/">
                    <img ngSrc="assets/images/home.svg" alt="Golf AI" width="32" height="32">
                </a>
                <!-- @if(showMenu){
                <button (click)="showMenu.set(false)">
                    <img src="assets/images/closeWhite.svg" alt="">
                </button>
                } -->
            </div>
            <ul class="menu-list">
                <li>
                    <a (click)="openBookingForm()">
                        <i>
                            <img ngSrc="assets/images/tee-time-icon.svg" alt="" width="30" height="33">
                        </i>
                        <span>{{'Search Tee Times' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/article">
                        <i><img ngSrc="assets/images/today-golf-icon.svg" alt="" width="37" height="13"></i>

                        <span>{{'TodayInGolf' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/play-golf">
                        <i><img ngSrc="assets/images/play-golf-white.svg" alt="" width="21" height="36"></i>
                        <span>{{'Play Golf' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a (click)="setQuestion('Golf Rules Questions')">
                        <i><img ngSrc="assets/images/rule-icon.svg" alt="" width="31" height="37"></i>
                        <span>{{'Golf Rules' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/discover/pgatour">
                        <i><img ngSrc="assets/images/pga-tour.svg" alt="PGA Tour" width="96" height="17" style="height: auto"></i>
                        <span>{{'PGA Tour' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/discover/liv">
                        <i><img ngSrc="assets/images/liv-golf-menu.svg" alt="LIV Golf" width="91" height="16" style="height: auto"></i>
                        <span>{{'LIV Golf' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/discover/owgr">
                        <i><img ngSrc="assets/images/owgr-menu-btn.svg" alt="OWGR" width="90" height="20" style="height: auto"></i>
                        <span>{{'OWGR' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a href="https://courses.golf.ai" target="_blank" rel="noopener noreferrer" (click)="showMenu.set(false)">
                        <i><img ngSrc="assets/images/courses-icon.svg" alt="Courses" width="24" height="24"></i>
                        <span>{{'Courses' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
                <li>
                    <a routerLinkActive="active" routerLink="/about-us" (click)="showMenu.set(false)">
                        <i><img ngSrc="assets/images/about-us-icon.svg" alt="About Us" width="24" height="24"></i>
                        <span>{{'About Us' | translate}}</span>
                        <img ngSrc="assets/images/right-arrow-white.svg" alt="" width="10" height="18">
                    </a>
                </li>
            </ul>
            <div class="menu-bottom">
                @if (!isSignedIn()) {
                    <button class="sign-up-btn btn-white" (click)="loginWithSso()">
                        {{'Login or Sign up' | translate}}
                    </button>
                } @else {
                    <!-- @if(user().hasCourse) {
                        <button class="sign-up-btn border-btn" (click)="goToCoursePortal()">{{'Manage Courses' | translate}}</button>
                    } -->
                    <button class="sign-up-btn" (click)="logOut()">
                        {{'Logout' | translate}}
                    </button>
                    }
            </div>
            
        </div>
        <div class="logoBg">
            <a routerLink="/">
                <img class="top-logo mr-2" ngSrc="assets/images/logo.svg" alt="Golf AI" width="44" height="28" loading="eager">
            </a>
        </div>
        <!-- <div class="mainLogo d-none d-md-block">
            <img src="assets/images/logo.svg" alt="Golf AI">
        </div> -->
        <!-- menuBlock -->
        <!-- menuBlock -->
        <div class="d-inline-flex right-menu">
            @if (isSignedIn()){
            <div class="profileBg">
                <a routerLink="settings/user-settings" class="profile" aria-label="User settings" [class.noImage]="!user().imageUrl">
                    @if (user().imageUrl){
                    <img [src]="user().imageUrl" [attr.alt]="user().name + ' profile picture'" decoding="async">
                    } @else {
                    <div class="profile-letter">
                        {{user().name.substring(0, 2).toUpperCase()}}
                    </div>
                    }
                </a>
            </div>
            } @else if (url !== '/login' && url !== '/signup') {
            <a (click)="loginWithSso()" class="smlBtn">{{'Login or Sign up' | translate}}</a>
            }
        </div>
    </div>
</div>